import { render, staticRenderFns } from "./ModalRegister.vue?vue&type=template&id=3ba1bc8b&scoped=true&"
import script from "./ModalRegister.vue?vue&type=script&lang=js&"
export * from "./ModalRegister.vue?vue&type=script&lang=js&"
import style0 from "./ModalRegister.vue?vue&type=style&index=0&id=3ba1bc8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba1bc8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTextField})
